import { render, staticRenderFns } from "./Ambientes.vue?vue&type=template&id=473a7f3a&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform&"
import script from "./Ambientes.vue?vue&type=script&lang=js&"
export * from "./Ambientes.vue?vue&type=script&lang=js&"
import style0 from "./Ambientes.vue?vue&type=style&index=0&id=473a7f3a&lang=scss&scoped=true&"
import style1 from "./Ambientes.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473a7f3a",
  null
  
)

export default component.exports